const LegalText = () => {
  return (
    <section className="py-3">
      <div className="container">
        <div className="row justify-content-center mb-4">
          <div className="col-12">
            <h2 className="text-black font-bold text-uppercase fs-4">
              Legal
            </h2>
          </div>
        </div>
        <div className="row justify-content-center mb-4">
          <div className="col">
            <p>Welcome to Brand Acumen. The content on this website—including all text, images, logos, trademarks, and other materials—is the property of Brand Acumen and is protected under applicable intellectual property laws.</p>
            <p>By accessing this site, you agree not to reproduce, distribute, transmit, modify, or create derivative works from any portion of the site without prior written consent from Brand Acumen.</p>
            <p>All trademarks, service marks, and trade names referenced on this site are the property of their respective owners and are used for identification purposes only.</p>
            <h2 className="text-black font-bold text-uppercase fs-4">Confidentiality & Client Work</h2>
            <p>Any examples of past work or client engagements presented on this site are for illustrative purposes only. Specific project details may be anonymized or modified to protect client confidentiality. Brand Acumen adheres to strict non-disclosure agreements and upholds industry-standard confidentiality protocols in all client relationships.</p>
            <h2 className="text-black font-bold text-uppercase fs-4">Industry Compliance</h2>
            <p>Brand Acumen is committed to regulatory and ethical compliance across all industries we serve, including pharmaceuticals, biotechnology, medical devices, and cannabis. Our brand development processes—including naming, trademark screening, transliteration, linguistic review, and regulatory strategy—are designed with global compliance in mind.</p>
            <p>We regularly consider the requirements and guidance of major health authorities, including:</p>
            <ul>
              <li>The U.S. Food and Drug Administration (FDA), including the Office of Prescription Drug Promotion (OPDP) and the Center for Drug Evaluation and Research (CDER)</li>
              <li>The European Medicines Agency (EMA), including the Name Review Group (NRG)</li>
            </ul>
            <p>Brand Acumen does not provide legal or regulatory approval services, but we work closely with clients and their legal counsel to ensure brand strategies align with relevant submission and approval processes.</p>
            <p>Nothing on this website should be construed as legal, regulatory, or medical advice. For questions regarding compliance, naming methodology, or service engagement, please contact us directly.</p>
            <p>&copy; 2025 Brand Acumen Studios, LLC. All rights reserved</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalText;
